import { type MutableRefObject, useRef } from 'react';

/**
 * Use when you need to access the most up-to-date version of a value, like a
 * state variable, in a callback that you don't want to or can't redefine on
 * every render.
 */
export const useUpToDateValue = <T>(value: T): MutableRefObject<T> => {
  const currentValue = useRef(value);

  currentValue.current = value;

  return currentValue;
};
